/**
 * Use the CSS tab above to style your Element's container.
 */
import React from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { useStripeSecurityValidation } from './usePaymentSecurity';
import './Styles.css';
const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: '#32325d',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4'
      }
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a'
    }
  }
};
function CardSection() {
  const stripe = useStripe();
  const elements = useElements();
  useStripeSecurityValidation(stripe, elements);

  return (
    <label>
      <p style={{ paddingBottom: '20px', paddingRight: '10px', fontSize: '14px' }}>Card details</p>
      <CardElement options={CARD_ELEMENT_OPTIONS} />
      {/* <CardElement /> */}
    </label>
  );
}
export default CardSection;
